export const CLEAR_STATUS = 'ui/CLEAR_STATUS'

export const SHOW_INFO_MESSAGE = 'ui/SHOW_INFO_MESSAGE'
export const HIDE_INFO_MESSAGE = 'ui/HIDE_INFO_MESSAGE'
